import { render, staticRenderFns } from "./PersonnelAdd.vue?vue&type=template&id=c3c07892&scoped=true&"
import script from "./PersonnelAdd.vue?vue&type=script&lang=ts&"
export * from "./PersonnelAdd.vue?vue&type=script&lang=ts&"
import style0 from "./PersonnelAdd.vue?vue&type=style&index=0&id=c3c07892&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c07892",
  null
  
)

export default component.exports